module.exports = __webpack_public_path__ + "img/TZS09435.e29c9bb9.jpeg";